var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.6615 1.85931H5.16883C3.11883 1.85931 1.8335 3.31065 1.8335 5.36531V10.908C1.8335 12.9626 3.11283 14.414 5.16883 14.414H11.0515C13.1082 14.414 14.3875 12.9626 14.3875 10.908V8.22265",
    stroke: "#c7222a ",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.88517 7.28057L10.8672 2.29857C11.4878 1.67857 12.4938 1.67857 13.1145 2.29857L13.9258 3.10991C14.5465 3.73057 14.5465 4.73724 13.9258 5.35724L8.91984 10.3632C8.6485 10.6346 8.2805 10.7872 7.8965 10.7872H5.39917L5.46184 8.26724C5.47117 7.89657 5.6225 7.54324 5.88517 7.28057Z",
    stroke: "#c7222a ",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1101 3.06832L13.1541 6.11232",
    stroke: "#c7222a ",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.21ab6e0a0efa8ec9801c624c3f99f651.svg";
export { ForwardRef as ReactComponent };